module.exports = __webpack_public_path__ + "img/richard-march-hoe.1cf62c38.png";